import { render, staticRenderFns } from "./declineBuddy.vue?vue&type=template&id=3712529b&"
import script from "./declineBuddy.vue?vue&type=script&lang=js&"
export * from "./declineBuddy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports